import React, { useState } from "react";
import imag1 from "../../../../assets/img/no-image-holder.png";
import HotelGalleryPopup from "./HotelGalleryPopup";
import { DefaultHotelIcon } from "../../../../helper/HwIcon";

const imgs = [1, 2];
export const HotelGallery = ({ images }) => {
  const [showGalleryPopup, setShowGalleryPopup] = useState(false);

  const handleViewAllClick = () => {
    setShowGalleryPopup(true);
  };

  return (
    <>
      <div className="col-xl-8 col-lg-7 hw-hotel--singleList__hotelGallery">
        <div className="row hw-hotel--imageGallery h-100">
          <div className="col-8">
            <div className="hw-img--main">
              {
                images?.[0] ? <img src={images?.[0] ?? imag1} alt="image" /> : <DefaultHotelIcon/>
              }
            </div>
          </div>
          <div className="col-4">
            <div className="row hw-gapx10 h-100">
              {imgs.map((i) => {
                return (
                <div className="col-12">
                    <div className="hw-img--grid">
                      <img src={images?.[i] ?? imag1} alt="image" />
                    {i === imgs.length ? (
                      // remove this once UI testing is done
                      // && images?.length > imgs.length
                      <a className="hw-btn hw-btn--circleWhite" onClick={handleViewAllClick}>View All</a>
                    ) : null}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>

      {/* Image Gallery Popup */}
      <HotelGalleryPopup
        show={showGalleryPopup}
        setShow={setShowGalleryPopup}
        images={images}
        initialIndex={0}
      />
    </>
  );
};
